import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
const LeftArrow = ({ customLeftArrow, getState, previous, disabled, rtl }) => {
    if (customLeftArrow) {
        return React.cloneElement(customLeftArrow, {
            onClick: () => previous(),
            carouselState: getState(),
            disabled: disabled,
            rtl: rtl
        });
    }
    const rtlClassName = rtl ? "rtl" : "";
    return (_jsx("button", { "aria-label": "Go to previous slide", className: `react-multiple-carousel__arrow react-multiple-carousel__arrow--left ${rtlClassName}`, onClick: () => previous(), type: "button", disabled: disabled }));
};
const RightArrow = ({ customRightArrow, getState, next, disabled, rtl }) => {
    if (customRightArrow) {
        return React.cloneElement(customRightArrow, {
            onClick: () => next(),
            carouselState: getState(),
            disabled: disabled,
            rtl: rtl
        });
    }
    const rtlClassName = rtl ? "rtl" : "";
    return (_jsx("button", { "aria-label": "Go to next slide", className: `react-multiple-carousel__arrow react-multiple-carousel__arrow--right ${rtlClassName}`, onClick: () => next(), type: "button", disabled: disabled }));
};
export { LeftArrow, RightArrow };
